
// import Swiper from 'swiper/bundle';
import Swiper from 'swiper/bundle';
// import 'swiper/css';

export default () => {
    const ageSlider = document.querySelector('.swiper.age');
    let paginationBullets = false;
    if (ageSlider) {
        paginationBullets = ageSlider.querySelectorAll(".swiper-pagination-bullet");
        new Swiper(ageSlider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true,
            spaceBetween: 40,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                type: 'custom',
                bulletElement: 'div',
            },
            lazy: {
                loadPrevNext: true,
            },
        }).on('slideChange', function (e) {
            if(paginationBullets){
                paginationBullets.forEach((el, i) => { el.classList.remove('swiper-pagination-current')});
                paginationBullets[e.activeIndex].classList.add('swiper-pagination-current');
            }
        });
    }
    if(paginationBullets){
        paginationBullets.forEach((element, index, paginationBullets) => { 
            element.addEventListener("mousedown", function(e) {
                paginationBullets.forEach((el, i) => { el.classList.remove('swiper-pagination-current')});
                element.classList.add('swiper-pagination-current');
            });
        });
    }
}
